export const ADD_SUCCESS = 'Новый контрагент добавлен';
export const ADD_ERROR = 'Не удалось добавить контрагента';
